import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appEmbedData = { image: '_media' };
var _array = {
    checkboxGroupOptions: '_checkboxGroup',
    validation: '_inputFieldArrayType',
};
var _arrayItems = { number: '_numberType', object: '_objectType' };
var _arrayType = { items: '_arrayItems' };
var _arrayTypeArrayItems = {
    numberOptions: '_inputFieldNumberType',
    objectOptions: '_inputFieldObjectType',
};
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _boolean = { checkboxOptions: '_checkbox' };
var _checkbox = { label: '_richContent' };
var _checkboxGroup = { description: '_richContent', options: '_option' };
var _checkboxGroupOption = { media: '_mediaItem' };
var _commonImage = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _createSpamSubmissionRequest = { spamSubmission: '_spamSubmission' };
var _createSpamSubmissionResponse = { spamSubmission: '_spamSubmission' };
var _deleteSpamSubmissionRequest = {};
var _deleteSpamSubmissionResponse = {};
var _design = { poll: '_pollDesign' };
var _displayField = { header: '_header', richText: '_richText' };
var _dropdown = { description: '_richContent' };
var _fileUpload = { description: '_richContent' };
var _form = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    fields: '_formField',
    fieldsV2: '_formFieldV2',
    deletedFields: '_formField',
    deletedFieldsV2: '_formFieldV2',
    nestedForms: '_nestedForm',
};
var _formField = { validation: '_validation' };
var _formFieldV2 = {
    inputOptions: '_inputField',
    displayOptions: '_displayField',
    submitOptions: '_submitButton',
};
var _formSubmission = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getSpamSubmissionRequest = {};
var _getSpamSubmissionResponse = { spamSubmission: '_spamSubmission' };
var _header = { content: '_richContent' };
var _image = { media: '_media' };
var _imageData = { image: '_media' };
var _inputField = {
    stringOptions: '_string',
    numberOptions: '_number',
    booleanOptions: '_boolean',
    arrayOptions: '_array',
    objectOptions: '_object',
    wixFileOptions: '_wixFile',
    paymentOptions: '_payment',
};
var _inputFieldArrayType = { items: '_arrayTypeArrayItems' };
var _inputFieldNumberType = {
    maximum: 'google.protobuf.DoubleValue',
    minimum: 'google.protobuf.DoubleValue',
    multipleOf: 'google.protobuf.DoubleValue',
    enum: 'google.protobuf.DoubleValue',
};
var _inputFieldObjectType = { properties: 'Map#_objectTypePropertiesType' };
var _item = { image: '_image', video: '_video' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _media = { duration: 'google.protobuf.DoubleValue' };
var _mediaItem = { image: '_commonImage' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _nestedForm = { form: '_form' };
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _number = {
    numberInputOptions: '_numberInput',
    validation: '_inputFieldNumberType',
};
var _numberInput = { description: '_richContent' };
var _numberType = {
    maximum: 'google.protobuf.DoubleValue',
    minimum: 'google.protobuf.DoubleValue',
    multipleOf: 'google.protobuf.DoubleValue',
    enum: 'google.protobuf.DoubleValue',
};
var _object = { object: '_inputFieldObjectType' };
var _objectType = { properties: 'Map#_propertiesType' };
var _objectTypePropertiesType = {
    numberOptions: '_inputFieldNumberType',
    arrayOptions: '_inputFieldArrayType',
};
var _option = { media: '_mediaItem' };
var _payment = { checkboxGroupOptions: '_paymentCheckboxGroup' };
var _paymentCheckboxGroup = {
    description: '_richContent',
    options: '_checkboxGroupOption',
};
var _poll = { image: '_media', options: '_pollOption' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _pollOption = { image: '_media' };
var _propertiesType = { number: '_numberType', array: '_arrayType' };
var _querySpamSubmissionsRequest = {};
var _querySpamSubmissionsResponse = { spamSubmissions: '_spamSubmission' };
var _radioGroup = { description: '_richContent' };
var _reportNotSpamSubmissionRequest = {};
var _reportNotSpamSubmissionResponse = { submission: '_formSubmission' };
var _reportSpamSubmissionRequest = {};
var _reportSpamSubmissionResponse = { spamSubmission: '_spamSubmission' };
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _richText = { content: '_richContent' };
var _spamSubmission = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _string = {
    textInputOptions: '_textInput',
    radioGroupOptions: '_radioGroup',
    dropdownOptions: '_dropdown',
};
var _submitButton = { thankYouMessage: '_thankYouMessage' };
var _textInput = { description: '_richContent' };
var _thankYouMessage = { text: '_richContent' };
var _updateSpamSubmissionRequest = {
    mask: 'google.protobuf.FieldMask',
    spamSubmission: '_spamSubmission',
};
var _updateSpamSubmissionResponse = { spamSubmission: '_spamSubmission' };
var _validateSpamRequest = { submission: '_formSubmission', form: '_form' };
var _validateSpamResponse = { spamSubmission: '_spamSubmission' };
var _validation = {
    number: '_numberType',
    array: '_arrayType',
    object: '_objectType',
};
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
var _wixFile = { fileUploadOptions: '_fileUpload' };
function resolveWixFormsV4FormSpamSubmissionServiceUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/_api/form-spam-submission-service',
                destPath: '',
            },
            {
                srcPath: '/form-spam-submission-service',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/form-spam-submission-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/form-spam-submission-service',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/form-spam-submission-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/form-spam-submission-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/form-spam-submission-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/form-spam-submission-service',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/form-spam-submission-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/form-spam-submission-service',
                destPath: '',
            },
            {
                srcPath: '/form-spam-submission-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/form-spam-submission-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Checks if submission is a spam. For spam, persists a spam submission. */
export function validateSpam(payload) {
    var _a = serializer(_validateSpamRequest, {
        _appEmbedData: _appEmbedData,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _boolean: _boolean,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _checkboxGroupOption: _checkboxGroupOption,
        _commonImage: _commonImage,
        _design: _design,
        _displayField: _displayField,
        _dropdown: _dropdown,
        _fileUpload: _fileUpload,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formSubmission: _formSubmission,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _header: _header,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _item: _item,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _payment: _payment,
        _paymentCheckboxGroup: _paymentCheckboxGroup,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _richContent: _richContent,
        _richText: _richText,
        _string: _string,
        _submitButton: _submitButton,
        _textInput: _textInput,
        _thankYouMessage: _thankYouMessage,
        _validation: _validation,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateSpamResponse, {
        _spamSubmission: _spamSubmission,
    }).fromJSON;
    function __validateSpam(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.spam_submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionService.ValidateSpam',
            url: resolveWixFormsV4FormSpamSubmissionServiceUrl({
                protoPath: '/v4/spam-submissions/validation',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateSpam.fromReq = fromReq;
    __validateSpam.__isAmbassador = true;
    return __validateSpam;
}
/**
 * Creates a new spam submission.
 * To upload submission media, use the FormSubmissionService.getMediaUploadUrl endpoint
 */
export function createSpamSubmission(payload) {
    var _a = serializer(_createSpamSubmissionRequest, { _spamSubmission: _spamSubmission }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createSpamSubmissionResponse, {
        _spamSubmission: _spamSubmission,
    }).fromJSON;
    function __createSpamSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.spam_submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionService.CreateSpamSubmission',
            url: resolveWixFormsV4FormSpamSubmissionServiceUrl({
                protoPath: '/v4/spam-submissions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSpamSubmission.fromReq = fromReq;
    __createSpamSubmission.__isAmbassador = true;
    return __createSpamSubmission;
}
/** Get a spam submission by id. */
export function getSpamSubmission(payload) {
    var _a = serializer(_getSpamSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSpamSubmissionResponse, {
        _spamSubmission: _spamSubmission,
    }).fromJSON;
    function __getSpamSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.spam_submission',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionService.GetSpamSubmission',
            url: resolveWixFormsV4FormSpamSubmissionServiceUrl({
                protoPath: '/v4/spam-submissions/{spamSubmissionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSpamSubmission.fromReq = fromReq;
    __getSpamSubmission.__isAmbassador = true;
    return __getSpamSubmission;
}
/** Delete a spam submission. */
export function deleteSpamSubmission(payload) {
    var _a = serializer(_deleteSpamSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteSpamSubmissionResponse, {}).fromJSON;
    function __deleteSpamSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.spam_submission',
            method: 'DELETE',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionService.DeleteSpamSubmission',
            url: resolveWixFormsV4FormSpamSubmissionServiceUrl({
                protoPath: '/v4/spam-submissions/{spamSubmissionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteSpamSubmission.fromReq = fromReq;
    __deleteSpamSubmission.__isAmbassador = true;
    return __deleteSpamSubmission;
}
/**
 * Report a spam submission as not spam. The submission is created, and the spam one is deleted.
 * Submission automations are triggered the same way as in standard submission creation flow.
 */
export function reportNotSpamSubmission(payload) {
    var _a = serializer(_reportNotSpamSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reportNotSpamSubmissionResponse, {
        _formSubmission: _formSubmission,
    }).fromJSON;
    function __reportNotSpamSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.spam_submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionService.ReportNotSpamSubmission',
            url: resolveWixFormsV4FormSpamSubmissionServiceUrl({
                protoPath: '/v4/spam-submissions/{spamSubmissionId}/report-not-spam',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reportNotSpamSubmission.fromReq = fromReq;
    __reportNotSpamSubmission.__isAmbassador = true;
    return __reportNotSpamSubmission;
}
/** Report a submission as spam. The spam submission is created, and the submission is deleted. */
export function reportSpamSubmission(payload) {
    var _a = serializer(_reportSpamSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reportSpamSubmissionResponse, {
        _spamSubmission: _spamSubmission,
    }).fromJSON;
    function __reportSpamSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.spam_submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionService.ReportSpamSubmission',
            url: resolveWixFormsV4FormSpamSubmissionServiceUrl({
                protoPath: '/v4/submissions/{submissionId}/report-spam',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reportSpamSubmission.fromReq = fromReq;
    __reportSpamSubmission.__isAmbassador = true;
    return __reportSpamSubmission;
}
/** Query spam submissions using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language). */
export function querySpamSubmissions(payload) {
    var _a = serializer(_querySpamSubmissionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_querySpamSubmissionsResponse, {
        _spamSubmission: _spamSubmission,
    }).fromJSON;
    function __querySpamSubmissions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.spam_submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionService.QuerySpamSubmissions',
            url: resolveWixFormsV4FormSpamSubmissionServiceUrl({
                protoPath: '/v4/spam-submissions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __querySpamSubmissions.fromReq = fromReq;
    __querySpamSubmissions.__isAmbassador = true;
    return __querySpamSubmissions;
}
/**
 * Updates a spam submission, supports partial update.
 * You need to pass the latest 'revision' for a successful update.
 */
export function updateSpamSubmission(payload) {
    var _a = serializer(_updateSpamSubmissionRequest, { _spamSubmission: _spamSubmission }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSpamSubmissionResponse, {
        _spamSubmission: _spamSubmission,
    }).fromJSON;
    function __updateSpamSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.spam_submission',
            method: 'PATCH',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionService.UpdateSpamSubmission',
            url: resolveWixFormsV4FormSpamSubmissionServiceUrl({
                protoPath: '/v4/spam-submissions/{spamSubmission.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSpamSubmission.fromReq = fromReq;
    __updateSpamSubmission.__isAmbassador = true;
    return __updateSpamSubmission;
}
//# sourceMappingURL=http.impl.js.map